import { render, staticRenderFns } from "./DetailsPrint.vue?vue&type=template&id=a636cbba&scoped=true&"
import script from "./DetailsPrint.vue?vue&type=script&lang=js&"
export * from "./DetailsPrint.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPrint.vue?vue&type=style&index=0&id=a636cbba&lang=scss&scoped=true&"
import style1 from "./DetailsPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a636cbba",
  null
  
)

export default component.exports